import { TextComponentProps } from "./TextComponent";
import {
  buttonWhite,
  buttonOrange,
  primaryColors,
} from "../../assets/styles/helpers/colors.styles";
export const getTextComponentStyles = (
  color: TextComponentProps["color"],
  underline: TextComponentProps["underline"],
  uppercase: TextComponentProps["uppercase"],
  dark?: boolean
) => {
  switch (color) {
    case "primary":
      return {
        padding: "0 0.5rem",
        minWidth: "0",
        backgroundColor: buttonWhite.text.background,
        border: "none",
        color: dark ? primaryColors.black : buttonWhite.text.font,
        textDecoration: underline ? "underline" : "none",
        textTransform: uppercase ? "uppercase" : "none",

        cursor: "pointer",
        "&.Mui-disabled": {
          color: buttonWhite.text.fontDisabled,
        },
        "&:hover": {
          color: dark
            ? buttonWhite.text.fontDisabled
            : buttonWhite.text.fontHover,
        },
        "&:active": {
          color: buttonWhite.text.fontActive,
        },
      };
    case "secondary":
      return {
        padding: "0 0.5rem",
        minWidth: "0",
        backgroundColor: buttonOrange.text.background,
        border: "none",
        color: buttonOrange.text.font,
        textDecoration: underline ? "underline" : "none",
        textTransform: uppercase ? "uppercase" : "none",

        cursor: "pointer",

        "&.Mui-disabled": {
          color: buttonOrange.text.fontDisabled,
        },
        "&:hover": {
          color: buttonOrange.text.fontHover,
        },
        "&:active": {
          color: buttonOrange.text.fontActive,
        },
      };
    default:
      return {
        padding: "0 0.5rem",
        minWidth: "0",
        backgroundColor: buttonWhite.text.background,
        border: "none",
        color: dark ? primaryColors.black : buttonWhite.text.font,
        textDecoration: underline ? "underline" : "none",
        textTransform: uppercase ? "uppercase" : "none",
        cursor: "pointer",
        "&.Mui-disabled": {
          color: buttonWhite.text.fontDisabled,
        },
        "&:hover": {
          color: dark
            ? buttonWhite.text.fontDisabled
            : buttonWhite.text.fontHover,
        },
        "&:active": {
          color: buttonWhite.text.fontActive,
        },
      };
  }
};
